import React, { Component } from 'react';
import _memoize from 'lodash.memoize';
import FiltersGroupContainer from './FiltersGroupContainer';
import Checkbox from '../../Checkbox/components/Checkbox';
import { getCheckboxChange, isCheckboxChecked } from '../helpers';
import FiltersGroupItemLabel from './FiltersGroupItemLabel';





















function filterIsChecked({ selectedValues, value, shouldReturnOptionAllSelection }) {
  return isCheckboxChecked(value, selectedValues, shouldReturnOptionAllSelection);
}

export default class CheckboxFiltersGroup extends Component {
  defaultValue = null;

  handleFilterChange = _memoize((
  { value }) =>
  () => {
    const { onChange, selectedValues, shouldReturnOptionAllSelection, filterFacets } = this.props;

    const changes = getCheckboxChange(
      value,
      selectedValues,
      this.defaultValue,
      shouldReturnOptionAllSelection,
      filterFacets
    );
    return onChange(changes);
  });

  static defaultProps = {
    selectedValues: []
  };

  constructor(props) {
    super(props);

    const defaultFacet = props.filterFacets.find((facet) => facet.selectedDefault);
    this.defaultValue = defaultFacet ? defaultFacet.value : undefined;
  }

  render() {
    const { filterFacets,
      label: groupLabel,
      isCollapsible,
      openedByDefault,
      stats,
      selectedValues,
      minWidth,
      shouldReturnOptionAllSelection
    } = this.props;

    return (
      <FiltersGroupContainer
        label={groupLabel}
        isCollapsible={isCollapsible}
        openedByDefault={openedByDefault}
        minWidth={minWidth}>

        {
        filterFacets.map(({ label, value, disabled, statKey }) =>
        <Checkbox
          key={value}
          onChange={this.handleFilterChange({ value })}
          checked={Boolean(filterIsChecked({
            selectedValues,
            value,
            shouldReturnOptionAllSelection
          }))}
          disabled={disabled}>

              <FiltersGroupItemLabel
            label={label}
            stats={stats}
            statKey={statKey} />

            </Checkbox>
        )}

      </FiltersGroupContainer>);

  }
}